
import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, RotateCcwIcon } from './icons';
import { TryOnResult } from '../services/db';

interface HistoryViewPageProps {
    item: TryOnResult;
    onClose: () => void;
    onTryAgain?: () => void;
}

const HistoryViewPage: React.FC<HistoryViewPageProps> = ({ item, onClose, onTryAgain }) => {
    return (
        <motion.div
            initial={{ opacity: 0, x: '100%' }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 200 }}
            className="fixed inset-0 z-[100] bg-white flex flex-col"
        >
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-100 bg-white">
                <button
                    onClick={onClose}
                    className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                    aria-label="Back"
                >
                    <XIcon className="w-6 h-6 text-gray-800" />
                </button>
                <span className="font-serif text-lg font-bold text-gray-800">تفاصيل التجربة</span>
                <div className="w-10"></div> {/* Spacer */}
            </div>

            {/* Main Content */}
            <div className="flex-grow overflow-y-auto bg-gray-50 flex flex-col items-center">
                {/* Full Image Container */}
                <div className="w-full max-w-md bg-white shadow-xl relative aspect-[3/4] sm:mt-4 sm:rounded-2xl overflow-hidden">
                    <img
                        src={item.imageUrl}
                        alt="Try-on Result"
                        className="w-full h-full object-contain"
                    />
                </div>

                {/* Details Card */}
                <div className="w-full max-w-md p-6 flex flex-col gap-6">
                    <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
                        <div className="flex justify-between items-center mb-4">
                            <span className="text-gray-500 text-sm">تاريخ التجربة</span>
                            <span className="font-semibold text-gray-800">
                                {new Date(item.timestamp.seconds * 1000).toLocaleDateString()}
                            </span>
                        </div>
                        <div className="w-full h-px bg-gray-100 mb-4" />
                        <p className="text-gray-600 text-sm leading-relaxed text-center italic">
                            "هذه النتيجة تم توليدها باستخدام محرك الأصالة للذكاء الاصطناعي."
                        </p>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex flex-col gap-3 pb-10">
                        <button
                            onClick={() => {
                                const link = document.createElement('a');
                                link.href = item.imageUrl;
                                link.download = `styleme-${item.id}.jpg`;
                                link.click();
                            }}
                            className="w-full bg-purple-600 text-white font-bold py-4 rounded-xl shadow-lg shadow-purple-200 active:scale-95 transition-all text-center"
                        >
                            حفظ الصورة في الجهاز
                        </button>
                        <button
                            onClick={onClose}
                            className="w-full bg-white border border-gray-200 text-gray-700 font-bold py-4 rounded-xl active:scale-95 transition-all text-center flex items-center justify-center gap-2"
                        >
                            العودة للمتجر
                        </button>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default HistoryViewPage;
